import ShareAction from './components/ShareAction/ShareAction.js'
const shareActionLinks = [...document.querySelectorAll('[data-share-action-link]')]
for (let shareActionLink of shareActionLinks) {
    new ShareAction(shareActionLink)
}
